import React, { useState, useEffect } from "react";
import { Tooltip } from "@mui/material";
import { TagsWrapper } from "./MapStyled";
import { useHookstate } from "@hookstate/core";
import {
  MAP_GLOBAL_STATES,
  SIDENAV_GLOBAL_STATE,
  SITELOCATION_GLOBAL_STATE,
  SITEID_GLOBAL_STATE
} from "globalStore/globalStore";
import { useTranslation } from "react-i18next";
import PhotoIcon from "assets/svgIcons/CameraIcon";
import FlagIcon from "assets/svgIcons/FlagIcon";
import { SearchIcon } from "assets/svgIcons";
import SiteMapIcon from "assets/svgIcons/MapIcon";
import FullScreenMapIcon from "assets/svgIcons/FullMapIcon";
import { isUserAdmin } from "../../constant";
import {  useSelector } from "react-redux";
import DeactivateIcon from "assets/svgIcons/DeactivateIcon";
import MountainIcon from "assets/svgIcons/MapSubSIdeNav/MountainIcon";

const MapTopMenu = ({
  all,
  setAll,
  site,
  setSite,
  kmlLayerData,
  showHoleMarker,
  toggleShowHoleMarker,
}) => {
  const {
    getUserRole
  } = useSelector((state) => state.commonReducers) || [];

  const { sideDrawerState } = useHookstate(SIDENAV_GLOBAL_STATE);
  const { siteLocationGlobalData } = useHookstate(SITELOCATION_GLOBAL_STATE);
  const { siteId } = useHookstate(SITEID_GLOBAL_STATE);

  const { overlay, heightMapToggle, deactiveAllAction } = useHookstate(MAP_GLOBAL_STATES);

  const [showHeightMap, setShowHeightMap] = useState(false);

  const { t } = useTranslation();

  useEffect(() => {
    if (JSON.parse(localStorage.getItem("courseOverlay")) === null || undefined) {
      overlay.set(false);
      localStorage.setItem("courseOverlay", JSON.stringify(false));
    }
    let overlayState = JSON.parse(localStorage.getItem("courseOverlay"));
    overlay.set(overlayState);
  }, [JSON.parse(localStorage.getItem("courseOverlay"))]);

  useEffect(() => {
    heightMapToggle.set(false);
    setShowHeightMap(false);
  }, [siteId.get()]);

  const handleHeightMap = () => {
    heightMapToggle.set(true);
    setShowHeightMap((prev) => !prev);
  }
  
  return (
    <TagsWrapper className="display for-map-center-icons">
      {!siteLocationGlobalData.get() ? (
        <>
          <Tooltip title={t("Zoom_to_show_all")} arrow>
            <button
              className="tags"
              style={{
                background: all
                  ? "var(--selected-btn-bg)"
                  : "var(--unselect-btn-bg)",
              }}
              onClick={() => {
                setAll(true);
                setSite(false);
              }}
            >
              <SearchIcon
                color={all ? "var(--theme-text)" : "var(--text-primary)"}
              />
            </button>
          </Tooltip>
          <Tooltip title={t("Zoom_to_site_extents")} arrow>
            <button
              className="tags"
              style={{
                background: site
                  ? "var(--selected-btn-bg)"
                  : "var(--unselect-btn-bg)",
              }}
              onClick={() => {
                setSite(true);
                setAll(false);
              }}
            >
              <SiteMapIcon
                color={site ? "var(--theme-text)" : "var(--text-primary)"}
              />
            </button>
          </Tooltip>
          <Tooltip title="Hide navigation tabs" arrow>
            <button
              className="tags"
              style={{
                background: !sideDrawerState.get()
                  ? "var(--selected-btn-bg)"
                  : "var(--unselect-btn-bg)",
              }}
              onClick={() => sideDrawerState.set(!sideDrawerState.get())}
            >
              <FullScreenMapIcon
                color={
                  !sideDrawerState.get()
                    ? "var(--theme-text)"
                    : "var(--text-primary)"
                }
              />
            </button>
          </Tooltip>
          <Tooltip title={t("Show_hole_markers")} arrow>
            <button
              className="tags"
              style={{
                background: showHoleMarker
                  ? "var(--selected-btn-bg)"
                  : "var(--unselect-btn-bg)",
              }}
              onClick={toggleShowHoleMarker}
            >
              <FlagIcon
                color={
                  showHoleMarker ? "var(--theme-text)" : "var(--text-primary)"
                }
              />
            </button>
          </Tooltip>
          {kmlLayerData && kmlLayerData !== "" ? (
            <Tooltip title={t("Course_Overlay")} arrow>
              <button
                className="tags"
                style={{
                  background: overlay.get()
                    ? "var(--selected-btn-bg)"
                    : "var(--unselect-btn-bg)",
                }}
                onClick={() => {
                  overlay.set((prevState) => !prevState);
                  localStorage.setItem(
                    "courseOverlay",
                    JSON.stringify(overlay.get())
                  );
                }}
              >
                <PhotoIcon
                  color={
                    overlay.get() ? "var(--theme-text)" : "var(--text-primary)"
                  }
                />
              </button>
            </Tooltip>
          ) : (
            <></>
          )}

        {isUserAdmin(getUserRole && getUserRole?.Role) &&
          <Tooltip title="Height Map" arrow>
            <button
              className="tags"
              style={{
                background: showHeightMap
                    ? "var(--selected-btn-bg)"
                    : "var(--unselect-btn-bg)",
                }}
              onClick={() => handleHeightMap()}>
                <MountainIcon
                  width={30}
                  height={30}
                  color={
                  showHeightMap ? "var(--theme-text)" : "var(--text-primary)"
                }
                />
            </button>
          </Tooltip>
        }

      {deactiveAllAction.get()?
            <Tooltip title={t("Action_Zones_disabled")} arrow>
            <button
              className="tags"
            >
              <DeactivateIcon fill="red" 
              />
              {"AZ"}
            </button>
          </Tooltip>:<></>
        }
        </>
      ) : null}
    </TagsWrapper>
  );
};

export default MapTopMenu;
